import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
export const destinationAPI = createApi({
  reducerPath: "apidestination",
  baseQuery: fetchBaseQuery({
    baseUrl: "http://localhost:5001/",
  }),
  endpoints: (builder) => ({
    //QUERY ->GET,
    //MUTATION->POST/PUT/DELETE
    getAllDestination: builder.query({
      query: () => "destination",
      providesTags: ["Destinations"],
    }),
    //POST
    addDestination: builder.mutation({
      query: (destination) => ({
        url: "destination",
        method: "POST",
        body: destination,
      }),
      invalidatesTags: ["Destinations"],
    }),
    //DELETE
    deleteDestination: builder.mutation({
      query: ({ id }) => ({
        url: `destination/${id}`,
        method: "DELETE",
        body: id,
      }),
      invalidatesTags: ["Destinations"],
    }),
    //PUT
    updateDestination: builder.mutation({
      query: (destination) => ({
        url: `destination/${destination.id}`,
        method: "PUT",
        body: destination,
      }),
      invalidatesTags: ["Destinations"],
    }),
  }),
});
//addDestination -> useAddDestinationMutation,
// deleteDestination->useDeleteDestinationMutation
//updateDestination->useUpdateDestinationMutation
export const {
  useGetAllDestinationQuery,
  useAddDestinationMutation,
  useUpdateDestinationMutation,
  useDeleteDestinationMutation,
} = destinationAPI;
